import { frequencyForRule, type RuleHash } from './rule';

const DAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const ORDINAL_LABELS: Record<string, string> = {
  '1': '1st',
  '2': '2nd',
  '3': '3rd',
  '4': '4th',
  '5': '5th',
  '-1': 'last',
};

export function describeRule(rule: RuleHash): string {
  const frequency = frequencyForRule(rule);
  const cadence = (unit: string): string =>
    rule.interval === 1 ? `Every ${unit}` : `Every ${rule.interval} ${unit}s`;

  if (frequency === 'Daily') return cadence('day');
  if (frequency === 'Yearly') return cadence('year');

  if (frequency === 'Weekly') {
    const days = (rule.validations?.day ?? []).map((day) => DAY_LABELS[day]).filter(Boolean);
    return days.length > 0 ? `${cadence('week')} on ${days.join(', ')}` : cadence('week');
  }

  const daysOfWeek = Object.entries(rule.validations?.day_of_week ?? {});
  if (daysOfWeek.length > 0) {
    const parts = daysOfWeek.flatMap(([day, ordinals]) =>
      ordinals.map(
        (ordinal) =>
          `${ORDINAL_LABELS[String(ordinal)] ?? ordinal} ${DAY_LABELS[Number(day)] ?? day}`,
      ),
    );
    return `${cadence('month')} on the ${parts.join(', ')}`;
  }

  const daysOfMonth = (rule.validations?.day_of_month ?? []).map((day) =>
    day === -1 ? 'last day' : `day ${day}`,
  );
  return daysOfMonth.length > 0
    ? `${cadence('month')} on ${daysOfMonth.join(', ')}`
    : cadence('month');
}
